import { defineComponent as _defineComponent } from 'vue'
import LabelTypeSelection from "@/components/labelConfiguration/LabelTypeSelection.vue";
import FreeTextFieldsConfiguration from "@/components/labelConfiguration/FreeTextFieldsConfiguration.vue";
import {LabelTypeMetadata} from "@/models/NutritionLabels/LabelTypeMetadata";
import {vSelectOptionBase} from "@/typings/common";
import {computed, Ref, ref} from "vue";
import FreeTextPlaceholder from "@/models/NutritionLabels/FreeTextPlaceholder";
import {LabelLanguage} from "@/models/NutritionLabels/LabelLanguage";
import LabelConfiguration from "@/components/labelConfiguration/LabelConfiguration.vue";
import {LabelConfigurationModel} from "@/models/NutritionLabels/v2/LabelConfigurationModel";
import NutritionLabelRepository from "@/utils/API/NutritionLabelRepository";
import {LabelConfigurationResponse} from "@/models/NutritionLabels/v2/LabelConfigurationResponse";
import {FreeTextAttributeType} from "@/models/NutritionLabels/v2/enums/FreeTextAttributeType";
import {LabelConfigurationOption} from "@/models/NutritionLabels/v2/enums/LabelConfigurationOption";
import {FreeTextFieldConfiguration} from "@/models/NutritionLabels/v2/FreeTextFieldConfiguration";
import {RecipeEntry} from "@/models/NutritionLabels/RecipeEntry";
import VUpsellModal from "@/components/modals/marketing/vUpsellModal.vue";

type UkFrontOfPackConfigurationProps = {
  country: string,
  recipeId: number,
  language: LabelLanguage,
  isTrial?: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UkFrontOfPackConfiguration',
  props: {
    country: null,
    recipeId: null,
    language: null,
    isTrial: { type: Boolean }
  },
  emits: ["update:renderModel"],
  setup(__props: any, { expose, emit }) {

const props = __props as {
  country: string,
  recipeId: number,
  language: LabelLanguage,
  isTrial?: boolean,
};



const isTrial = computed(() => !!props.isTrial);
const showTrialUpsellModal = ref(false);

const labelSelectionModel = ref<any>({});
const selectedFoPLabel = ref<vSelectOptionBase<string>>({ name: "", value: "" });
const freeTextPlaceholders = ref<FreeTextPlaceholder[]>([]);
const labelConfigurationModel: Ref<LabelConfigurationModel> = ref<LabelConfigurationModel>({
  hideOtherText: false,
  showAmountInSeparateColumn: false,
  showCarbsDV: false,
  showShortFooter: false,
  showSideBySidePanel: false,
  switchToElectrolyteMode: false,
  useMcgUnit: false,
  useNormalServingSizeFont: false,
  combineVoluntaryNutrients: false,
  hideTotalText: false,
  includeMonoPoly: false,
  includeOmegas: false,
  switchCalorieBreakdownFootnote: false,
  switchServingSizeText: false,
  useCondensedFont: false,
  useCondensedFormat: false,
  useInlineFootnote: false,
  useParForFrenchServingSize: false,
  proprietaryBlends: [],
  labelTypes: {},
  showProteinDV: false,
  recipes: [] as RecipeEntry[],
  widthCm: 7,
  shouldDisplaySugarAlcohol: false,
  shouldDisplayNutrientsSideBySide: false,
  shouldDisplayCalories449Text: false,
  showCalorieFromFatText: false,
  selectedCoreNutrients: [],
  selectedSupplementNutrients: [],
  selectedVoluntaryNutrients: [],
  showThcLogo: false,
  includeSaltFootnote: false,
  includeRi: false,
  includePerServingAnalysis: false,
  includeTrafficLightColoring: false,
  includeTextualIndicators: false
});
const requestedLabelConfigurations = ref<LabelConfigurationOption[]>([]);

const freeTextFields = computed<FreeTextFieldConfiguration>(() => {
  const rv: FreeTextFieldConfiguration = {};

  for (const placeholder of freeTextPlaceholders.value) {
    rv[placeholder.displayText] = placeholder.content;
  }

  return rv;
});

const renderModel = computed(() => {
  return {
    country: "Uk",
    labelName: selectedFoPLabel.value.value,
    renderModel: {
      recipeId: props.recipeId,
      language: props.language,
      freeTextFields: freeTextFields.value,
      ...labelConfigurationModel.value
    }
  };
});

expose({ renderModel });

async function onLabelSelect(selectedLabel: vSelectOptionBase<string>) {
  selectedFoPLabel.value = selectedLabel;
  await requestLabelConfigurations();

  emit("update:renderModel", renderModel.value);
}

async function requestLabelConfigurations() {
  const response = await NutritionLabelRepository.getConfigurationOptionsForLabelV2(
    "Uk",
    selectedFoPLabel.value.value
  );

  const {
    freeTextFields = [],
    configurationOptions = []
  } = response.data as LabelConfigurationResponse;

  requestedLabelConfigurations.value = configurationOptions;

  freeTextPlaceholders.value = freeTextFields.map<FreeTextPlaceholder>((field, index) => ({
    id: index + 1,
    displayText: field as FreeTextAttributeType,
    content: [] as string[],
  }));
}

function updateFreeTextFields(updatedFreeTextFields: FreeTextPlaceholder[]) {
  freeTextPlaceholders.value = updatedFreeTextFields;
  emit("update:renderModel");
}

function updateLabelConfigurationModel(updatedModel: LabelConfigurationModel) {
  labelConfigurationModel.value = updatedModel;
  emit("update:renderModel");
}

function closeTrialUpsellModal() {
  showTrialUpsellModal.value = false;
}

function handleTrialCardExpandAttempt(event: MouseEvent) {
  if (!isTrial.value) {
    return;
  }

  const targetElement = event.target as HTMLElement | null;
  const cardHeader = targetElement?.closest(".card-title") as HTMLElement | null;

  if (!cardHeader) {
    return;
  }

  const chevron = cardHeader.querySelector(".chevron") as HTMLElement | null;
  const isCollapsed = !!chevron && !chevron.classList.contains("active");

  if (!isCollapsed) {
    return;
  }

  showTrialUpsellModal.value = true;
}

return { __sfc: true,props, emit, isTrial, showTrialUpsellModal, labelSelectionModel, selectedFoPLabel, freeTextPlaceholders, labelConfigurationModel, requestedLabelConfigurations, freeTextFields, renderModel, onLabelSelect, requestLabelConfigurations, updateFreeTextFields, updateLabelConfigurationModel, closeTrialUpsellModal, handleTrialCardExpandAttempt, LabelTypeSelection, FreeTextFieldsConfiguration, LabelTypeMetadata, LabelConfiguration, VUpsellModal }
}

})